/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type QuickAddProductForRestaurantQueryVariables = Types.Exact<{
  lineageKey: Types.Scalars['String']['input'];
  restaurantId: Types.Scalars['String']['input'];
  costChannel?: Types.InputMaybe<Types.CostChannel>;
}>;

export type QuickAddProductForRestaurantQuery = {
  readonly __typename?: 'Query';
  readonly productForRestaurantByLineageKey: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isModifiable: boolean;
    readonly outOfStock: boolean;
    readonly cost: number;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
    };
  } | null;
};

export const QuickAddProductForRestaurantDocument = gql`
  query QuickAddProductForRestaurant(
    $lineageKey: String!
    $restaurantId: String!
    $costChannel: CostChannel
  ) {
    productForRestaurantByLineageKey(lineageKey: $lineageKey, restaurantId: $restaurantId) {
      __typename
      id
      slug
      name
      cost: channelCost(costChannel: $costChannel)
      isModifiable
      outOfStock
      restaurant {
        __typename
        id
        slug
        name
      }
    }
  }
`;

export function useQuickAddProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<QuickAddProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    QuickAddProductForRestaurantQuery,
    QuickAddProductForRestaurantQueryVariables
  >({ query: QuickAddProductForRestaurantDocument, ...options });
}
